<script setup>
import { ref } from 'vue'
import { sendJson } from '../lib/csrf'

const props = defineProps({
  recipeId: { type: Number, required: true },
  baseServes: { type: Number, default: 4 },
  updateUrl: { type: String, required: true },
  viewUrl: { type: String, default: '/current_recipe' },
})

const target = ref(props.baseServes)
const mode = ref('auto')
const state = ref('idle') // idle | sending | sent | error

function dec() { if (target.value > 1) target.value-- }
function inc() { if (target.value < 50) target.value++ }

async function send() {
  state.value = 'sending'
  try {
    await sendJson(props.updateUrl, { recipe_id: props.recipeId, serves: target.value, mode: mode.value }, 'PATCH')
    state.value = 'sent'
  } catch (e) {
    state.value = 'error'
  }
}
</script>

<template>
  <div class="card bg-base-200 border border-base-300">
    <div class="card-body py-4 flex-row flex-wrap items-center gap-4">
      <span class="font-semibold">Cook this</span>

      <div class="flex items-center gap-2">
        <span class="text-sm opacity-70">serves</span>
        <button type="button" class="btn btn-circle btn-xs btn-outline" aria-label="Fewer servings" @click="dec">−</button>
        <span class="w-6 text-center">{{ target }}</span>
        <button type="button" class="btn btn-circle btn-xs btn-outline" aria-label="More servings" @click="inc">+</button>
      </div>

      <select v-model="mode" class="select select-bordered select-sm">
        <option value="auto">auto layout</option>
        <option value="ingredients">ingredients first</option>
        <option value="method">method first</option>
        <option value="flow">flow table</option>
      </select>

      <button type="button" class="btn btn-primary btn-sm" :disabled="state === 'sending'" @click="send">
        {{ state === 'sending' ? 'Sending…' : 'Send to kitchen' }}
      </button>

      <span v-if="state === 'sent'" class="text-success text-sm">
        Sent ✓ <a :href="viewUrl" class="link">open the kitchen screen</a>
      </span>
      <span v-if="state === 'error'" class="text-error text-sm">Couldn't send — try again.</span>
    </div>
  </div>
</template>
